// src/utils/http.js
// 轻量 fetch 封装：自动拼接基域名、带上 Bearer Token、统一解析错误

const API_BASE =
  process.env.VUE_APP_API_BASE?.replace(/\/+$/, '') ||
  'https://web3schoolapi.web3school.info';

const TOKEN_KEY = 'web3school_token';

function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; }
}

export async function http(method, path, body = null, extraHeaders = {}) {
  const url = `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
  const headers = {
    'Content-Type': 'application/json',
    ...extraHeaders,
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, {
    method: method.toUpperCase(),
    headers,
    body: body ? JSON.stringify(body) : null,
  });

  // 可能没有返回体（204 等）
  let data = null;
  const text = await res.text();
  try { data = text ? JSON.parse(text) : null; } catch { data = null; }

  if (!res.ok) {
    const err = new Error(data?.error || data?.message || `HTTP_${res.status}`);
    err.status = res.status;
    err.payload = data || {};
    throw err;
  }

  return data;
}

export const get  = (path, headers)        => http('GET',  path, null, headers);
export const post = (path, body, headers)  => http('POST', path, body, headers);
